import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import TablePaginationActions from './TablePaginationActions';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  classes: PropTypes.shape({}).isRequired,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  count: PropTypes.number,
  onChangePage: PropTypes.func,
};

const defaultProps = {
  page: 0,
  rowsPerPage: 10,
  count: 0,
  onChangePage: null,
};

export function UnstyledORTable({ children, classes, rowsPerPage, page, count, onChangePage }) {
  return count <= rowsPerPage ? (
    <Table className={classes.table}>{children}</Table>
  ) : (
    <Table className={classes.table}>
      {children}
      <TableFooter>
        <TableRow>
          <TablePagination
            classes={{
              root: classes.paginationRoot,
              spacer: classes.paginationSpacer,
              caption: classes.paginationCaption,
              input: classes.paginationInput,
              toolbar: classes.paginationToolbar,
            }}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={onChangePage}
            ActionsComponent={TablePaginationActions}
          />
        </TableRow>
      </TableFooter>
    </Table>
  );
}

UnstyledORTable.propTypes = propTypes;
UnstyledORTable.defaultProps = defaultProps;

const styles = (theme) => ({
  table: {
    backgroundColor: theme.customColors.white,
    border: `1px solid ${theme.customColors.lightGrey}`,
    lineHeight: '1.8rem',
    borderRadius: '3px',
    borderCollapse: 'separate',
    '& th': {
      border: 0,
      height: '80px',
      paddingTop: '25px',
      fontSize: theme.typography.h6.fontSize,
      color: theme.customColors.black,
    },
    '& td': {
      border: 0,
      fontSize: theme.typography.subtitle1.fontSize,
    },
    '& tbody tr:nth-child(odd)': {
      backgroundColor: theme.customColors.coolGrey,
    },
    '& tfoot': {
      width: '100%',
    },
  },
  paginationRoot: {
    padding: 0,
    fontSize: '1rem',
    paddingRight: 'unset',
    '& span': {
      color: theme.customColors.lightGrey,
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
      display: 'inline-block',
      width: '20px',
      textAlign: 'center',
    },
    '& span:hover': {
      cursor: 'pointer',
    },
    '& button': {
      border: 'none',
      fontSize: '1rem',
      color: theme.palette.secondary.main,
      display: 'inline',
      cursor: 'pointer',
    },
  },
  paginationSpacer: {
    flex: 'unset',
  },
  // uses !important to prevent media query overwrites
  paginationCaption: {
    display: 'none !important',
  },
  paginationInput: {
    display: 'none !important',
  },
  paginationToolbar: {
    padding: theme.spacing(1),
    borderTop: '1px solid rgb(216, 216, 216)',
  },
  pageButtonStyles: {
    fontSize: '1rem',
  },
});

export default withStyles(styles)(UnstyledORTable);
